module.exports = __webpack_public_path__ + "img/time.40868d4b.svg";